/**
 * Shared display formatters.
 *
 * Extracted from the inline `new Intl.NumberFormat('hu-HU', { style: 'currency', currency: 'HUF', maximumFractionDigits: 0 })`
 * pattern that was duplicated across InventoryListPage, TopPartnersWidget and the
 * dashboard widgets. New consumers should import `formatCurrency` instead of
 * re-declaring the formatter inline.
 */

/**
 * Format a numeric amount as Hungarian Forint (HUF), no decimals.
 *
 * @example formatCurrency(1234567) // "1 234 567 Ft"
 */
export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('hu-HU', {
    style: 'currency',
    currency: 'HUF',
    maximumFractionDigits: 0,
  }).format(amount);
}
